import * as React from 'react';
import { Phone16 } from '@cian/ui-kit/icons';
import { useSelector } from 'react-redux';
import { getGaLabel } from '../../selectors/newbuilding';
import { TShowPhoneAction } from '../../types/analytics/call';
import { CallButton } from '../CallButton';
import { trackOpenContacts, trackShowPhone } from './tracking';

export interface IHeaderCallProps {
  placeType?: string;
  eventAction: TShowPhoneAction;
}

export const HeaderCall = ({ placeType = 'blockFicheringStickyHeader', eventAction }: IHeaderCallProps) => {
  const gaLabel = useSelector(getGaLabel);

  const onShowPhoneClick = React.useCallback(() => {
    trackShowPhone(gaLabel, eventAction);
  }, [gaLabel, eventAction]);

  const onOpenContactsClick = React.useCallback(() => {
    trackOpenContacts(gaLabel);
  }, [gaLabel]);

  return (
    <CallButton
      placeType={placeType}
      onOpenContactsClick={onOpenContactsClick}
      onShowPhoneClick={onShowPhoneClick}
      openContactsStyles={{ size: 'XS' as const }}
      showPhoneStyles={{ size: 'XS' as const, beforeIcon: <Phone16 color="white_100" /> }}
    />
  );
};

HeaderCall.displayName = 'GalleryCall';
